exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".participants-agt-time{height:22px}.participants-working-time{font-size:smaller;padding-left:4px;padding-right:4px;height:22px;width:135px}.participants-search{gap:20px;align-self:flex-end}.participants-external-person-heading{color:white;margin-top:12px;margin-bottom:8px}.participants-external-person-remove{color:white;width:fit-content;float:right;top:8px;right:10px;margin-right:8px !important;opacity:80%}.participants-external-person-remove:hover{cursor:pointer;opacity:80%;color:red}\n", ""]);

// exports
